{
  "account": {
    "title": "Mijn account",
    "list": {
      "title": "Accounts",
      "description": "Facturenlijst van gekoppelde rekeningen"
    },
    "form": {
      "name": {
        "title": "Naam",
        "description": "Je account naam"
      },
      "password": {
        "title": "Wachtwoord",
        "description": "Stel een nieuw wachtwoord in voor je account, laat het leeg om het huidige wachtwoord te behouden"
      },
      "emailPreferences": {
        "title": "E-mail voorkeuren",
        "description": "Selecteer soorten e-mail meldingen"
      }
    },
    "billing": "Factuurgegevens",
    "subscriptions": "Abonnementen",
    "manageSubscription": "Abonnement beheren",
    "popup": {
      "downgrade": "Weet je zeker dat je wilt downgraden? De downgrade zal onmiddellijk van toepassing zijn. <br/>Houd er rekening mee dat je niet in aanmerking komt voor een korting voor de resterende tijd van de huidige factureringsperiode.<br/>De nieuwe prijs zal worden toegepast op de volgende factureringsperiode.",
      "default": "Weet je zeker dat je je plan wilt wijzigen ?",
      "cancel": "Weet u zeker dat u uw abonnement wilt opzeggen?<br/> Uw website wordt nog vertaald tot het einde van uw huidige abonnementsperiode. Daarna wordt de vertaling uitgeschakeld.<br/> Houd er rekening mee dat u voor de ongebruikte periode geen recht heeft op een korting.",
      "resume": "Weet je zeker dat je je abonnement wilt hervatten?"
    }
  },
  "ai_translation": {
    "header": "AI-vertaling",
    "plan": {
      "header": "Prijzen voor AI-vertaling",
      "used": "Je hebt {words_used} / {words_allowed} vertaalde woorden gebruikt in je AI-credits.",
      "remaining": "Beschikbare AI-credits:",
      "words": "woorden",
      "add_more_credits": "Voeg meer AI-credits toe",
      "details": {
        "idiomatic_expressions": "Idiomatische en technische uitdrukkingen",
        "background_translation": "Vertalingen op de achtergrond",
        "page_context": "Pagina- en websitecontext voor vertaling",
        "perfect_quality": "Perfecte kwaliteit, betaalbare prijs",
        "no_recurring": "Geen terugkerende betaling, vooraf betaald quotum",
        "save_40": "Bespaar 40% vergeleken met het $20-abonnement",
        "save_50": "Bespaar 50% vergeleken met het $20-abonnement",
        "best_website": "Website die perfecte vertaalkwaliteit vereist"
      },
      "quota": "{estimated_words} woorden ~ {estimated_pages} pagina's"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-vertaling",
        "intro": "Linguise presenteert met trots Linguise AI Translation, een nieuwe premiumfunctie die gebruikmaakt van AI LLM-modellen (de meest recente modellen van Llama, geoptimaliseerd voor vertaaltaken). Ontworpen voor websites die een onberispelijke nauwkeurigheid vereisen, houdt het rekening met zowel de paginacontext als de volledige websitecontext voor ongeëvenaarde resultaten. Bied uw klanten de allerbeste vertaalkwaliteit en zorg ervoor dat hun boodschap in elke taal perfect overkomt.",
        "button": "Nu upgraden"
      },
      "alert": {
        "description": "Deze functie is niet inbegrepen in uw huidige abonnement en vereist een aparte aankoop. Activeer deze add-on om alle onderstaande opties te ontgrendelen."
      },
      "languages": {
        "title": "Pas AI-vertaling toe op talen",
        "description": "Selecteer de specifieke taal waarop u de AI-vertaling wilt toepassen"
      },
      "button": {
        "save": "Instellingen opslaan"
      },
      "form": {
        "rule_application": {
          "description": "Pas de AI-vertaling toe op statische inhoud, dynamische inhoud of beide",
          "title": "Toepassen op inhoud",
          "all": "Alle inhoud",
          "static": "Statische inhoud",
          "dynamic": "Dynamische inhoud"
        },
        "website_topic": {
          "title": "Website-onderwerp",
          "placeholder": "Sushirestaurant...",
          "description": "Definieer het onderwerp van uw website voor een betere vertaalkwaliteit (bijv. juridisch, sushirestaurant, webshop voor fietsonderdelen...).\nVoer het onderwerp van de website in het Engels in."
        },
        "apply_to_urls": {
          "title": "Toepassen op URL's",
          "description": "Selecteer specifieke URL's waar u de AI-vertaling wilt toepassen",
          "all_urls": "Alle URL's",
          "selected_urls": "Geselecteerde URL's",
          "label": "URL om op te solliciteren",
          "placeholder": "URL om op te solliciteren",
          "wildcard": "Jokerteken",
          "regex": "Reguliere expressie",
          "add": "Nieuw toevoegen",
          "expression": "Expressietype"
        },
        "apply_languages": {
          "title": "Toepassen op talen",
          "description": "Selecteer de specifieke taal waarop u de AI-vertaling wilt toepassen",
          "all_languages": "Alle talen",
          "selected_languages": "Geselecteerde talen",
          "placeholder": "Selecteer talen...",
          "feedback": "U moet een taal kiezen"
        },
        "enable_mode": {
          "title": "AI-VERTALING INSCHAKELEN",
          "description": "Kies hoe u de AI-vertaling wilt inschakelen.\nRegels zijn alleen van toepassing op de volgende regels.\nAlleen in de live-editor is het mogelijk om pagina voor pagina vertalingen in te schakelen vanuit de live-editorweergave.\nRegels en live-editor maken gebruik van beide functies.",
          "disabled": "Gehandicapt",
          "rules": "Alleen regels",
          "live_editor": "Alleen live-editor",
          "all": "Regels en live-editor"
        },
        "formality": {
          "title": "Formaliteit",
          "description": "Specificeer de mate van formaliteit in vertalingen, mogelijk belangrijk voor het publiek en de context. \"Neutraal\" probeert de formaliteit van de oorspronkelijke inhoud te behouden. \"Formeel\" is voor professionele, zakelijke of juridische inhoud (d.w.z. het gebruik van formele voornaamwoorden zoals \"usted\" in het Spaans). \"Informeel\" is voor informele, conversatiegerichte inhoud (d.w.z. het gebruik van \"tú\" in het Spaans).",
          "neutral": "Neutrale",
          "formal": "Formeel",
          "informal": "Informeel"
        },
        "sentence_structure": {
          "classic": "Klassiek",
          "short": "Korte en krachtige zinnen",
          "detailed": "Gedetailleerde en verklarende zinnen",
          "title": "Zinsstructuur",
          "description": "Definieer de voorkeursschrijfstijl."
        },
        "content_purpose": {
          "marketing": "Marketing/promotie (overtuigende, boeiende toon)",
          "technical": "Technisch/instructief (duidelijk, precies, actiegericht)",
          "support": "Klantenservice (empathisch, behulpzaam, geruststellend)",
          "legal": "Juridisch/compliance (precies, formeel, ondubbelzinnig)",
          "educational": "Educatief (duidelijk, gestructureerd, toegankelijk)",
          "title": "Inhoudelijk doel",
          "description": "Definieer het functionele doel van de te vertalen inhoud.",
          "other_placeholder": "Beschrijf het doel...",
          "other": "Overig (in het Engels)"
        },
        "target_audience": {
          "title": "Doelgroep",
          "description": "Specificatie van het beoogde publiek van de vertaalde inhoud (in het Engels).",
          "placeholder": "bijvoorbeeld Spaanstalige ouders, EU-privacyfunctionarissen"
        },
        "advanced": {
          "title": "Geavanceerde AI-instructies",
          "description": "Geavanceerde AI-instructies"
        },
        "override_default_translations": {
          "title": "Standaardvertaling overschrijven",
          "description": "Als deze optie op JA is ingesteld, wordt de inhoud geforceerd vertaald met AI (Linguise AI), zelfs als deze al is vertaald met Cloud AI-vertaling (standaardvertaalmodel)."
        },
        "force_replace_before": {
          "title": "AI-hervertaling forceren",
          "description": "Vertaal met AI opnieuw alle content waarvan de AI-vertaling vóór de geselecteerde datum is gemaakt, bijvoorbeeld content die met een ouder model is vertaald. De hervertaling vindt plaats bij het volgende bezoek aan de toepasselijke pagina’s volgens de regels en gebruikt je AI-tegoed.",
          "before_date": "Vóór een datum"
        },
        "model": {
          "current": "Huidige",
          "title": "Model",
          "description": "Selecteer het LLM-vertaalmodel dat u wilt gebruiken",
          "load_error": "Kan beschikbare modellen niet laden. Probeer het later opnieuw.",
          "thinking_warning": "Dit model maakt gebruik van een hoog niveau van redenering (\"denken\") en verbruikt aanzienlijk meer tokens per vertaling."
        },
        "override_manual_and_selected": {
          "no_default": "Nee (standaard)",
          "title": "Handmatige en geselecteerde vertalingen overschrijven",
          "description": "Standaard blijft een vertaling die u handmatig hebt bewerkt altijd op uw website staan, ook nadat er een AI-verbeterde vertaling is gegenereerd. Zet op JA om in plaats daarvan de AI-verbeterde vertaling te tonen. Uw handmatige vertalingen blijven bewaard en u kunt op elk moment terugschakelen. Dit geldt ook wanneer u de pagina's opnieuw vertaalt om nieuwe vertalingen te krijgen; de nieuwste vertaling wordt automatisch gebruikt."
        }
      },
      "message": {
        "save_success": "Van de huidige, reeds vertaalde inhoud zou het aantal pagina's dat met AI-vertaling zou worden verbeterd ongeveer {{ai_affected_urls}} zijn.",
        "save_success_only": "Instellingen succesvol opgeslagen."
      }
    },
    "pricing": {
      "plan": {
        "title": "Bestel AI-vertaalquotum",
        "buy_button": "KOOP AI VERTAALPAKKET"
      },
      "modal": {
        "title": "Planwijziging bevestigen",
        "description": "Weet u zeker dat u uw AI-vertaalplan wilt wijzigen?",
        "button_cancel": "Annuleren",
        "button_confirm": "Bevestigen",
        "loading": "Even geduld...",
        "amount": "Hoeveelheid",
        "credit": "Credit",
        "total_due": "Totaal verschuldigd"
      },
      "comparison": {
        "title": "Google Cloud AI-vertaling versus Linguise AI-vertaling",
        "list": {
          "0": {
            "google": "Snelle en betrouwbare vertalingen",
            "linguise": "Omgaan met idiomatische en technische uitdrukkingen"
          },
          "1": {
            "google": "Directe vertalingen van alle webpagina's",
            "linguise": "Generatie van de vertalingen op de achtergrond"
          },
          "2": {
            "google": "Beste kwaliteit, lage prijs",
            "linguise": "Perfecte kwaliteit, betaalbare prijs"
          },
          "3": {
            "google": "Het meest geschikt voor grote websites of een laag budget",
            "linguise": "Het beste voor websites die een perfecte vertaalkwaliteit vereisen"
          },
          "4": {
            "google": "Paginacontext voor vertaling",
            "linguise": "Pagina- en websitecontext voor vertaling"
          }
        }
      },
      "botom_banner": {
        "title": "Ervaar ongeëvenaarde vertaalnauwkeurigheid met de",
        "sub_title": "Nieuwe Linguise AI-vertaling",
        "description": "Linguise breidt haar automatische vertaaldiensten uit met de introductie van Linguise AI Translation, een krachtige nieuwe optie die gebruikmaakt van geavanceerde AI-vertaaltechnologie (LLM) (de meest recente Llama-modellen geoptimaliseerd voor vertalingen). Deze toevoeging biedt websiteontwikkelaars en webbureaus een nog hogere vertaalkwaliteit, ideaal voor projecten waarbij perfectie voorop staat. Linguise AI Translation vormt een aanvulling op onze bestaande, hoogwaardige Google Cloud AI-vertaalservice en biedt u meer flexibiliteit en precisie."
      }
    },
    "success": {
      "tab_title": "Bedankt voor uw aankoop van het AI Translation-abonnement!",
      "title": "Bedankt voor uw aankoop van het AI Translation-abonnement!",
      "subtitle": "Uw AI-vertaalplan is succesvol gekocht!",
      "message": "U kunt uw AI-vertaalplan beheren op de pagina met AI-vertaalinstellingen.",
      "home": "Beheer AI-vertaling"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Naam",
        "description": "Naam van de rekening"
      },
      "phone": {
        "title": "Telefoon",
        "description": "Telefoonrekening"
      },
      "email": {
        "title": "E-mail",
        "description": "E-mail van de facturerings rekening"
      },
      "address": {
        "title": "Adres",
        "description": "Adres van de facturerings rekening",
        "city": "Stad",
        "country": "Land",
        "address1": "Adres 1",
        "address2": "Adres 2",
        "postal": "Postcode",
        "state": "Staat"
      },
      "tax": {
        "title": "Btw nummer"
      }
    }
  },
  "checkouts": {
    "header": "Afrekenen",
    "payment_method": "Selecteer Betaalmethode",
    "stripe_card": "Creditcard (streep)",
    "paypal": "PayPal",
    "address": {
      "new": "Voer een nieuw factuuradres in",
      "existing": "Gebruik bestaand adres"
    },
    "pay_stripe": "Bevestig en betaal",
    "terms": "Door uw abonnement te bevestigen, geeft u Linguise toestemming om toekomstige betalingen bij u in rekening te brengen, in overeenstemming met onze voorwaarden. Je kunt je abonnement altijd opzeggen.",
    "coupon": {
      "title": "Heeft u een kortingsbon?",
      "placeholder": "Voer hier uw couponcode in",
      "apply": "Toepassen",
      "percent": "{{0}}% korting"
    },
    "add_new": "Nieuw toevoegen",
    "use_existing": "Gebruik bestaande betaalmethode",
    "recurring": {
      "month_single": "Maandelijks gefactureerd",
      "month_many": "Elke {{count}} maanden gefactureerd",
      "year_single": "Jaarlijks gefactureerd",
      "year_many": "Elke {{count}} jaar gefactureerd",
      "day_single": "Dagelijks gefactureerd",
      "day_many": "Elke {{count}} dagen gefactureerd",
      "week_single": "Wekelijks gefactureerd",
      "week_many": "Elke {{count}} weken gefactureerd"
    },
    "add_new_no_stripe": "Nieuwe kaart toevoegen",
    "summary": {
      "title": "Samenvatting",
      "subtotal": "Subtotaal",
      "total": "Totaal"
    }
  },
  "dashboard": {
    "main": {
      "title": "Dashboard"
    },
    "statistics": {
      "main_title": "Statistieken van de afgelopen 30 dagen",
      "characters": "Vertaalde tekens",
      "words": "Vertaalde woorden",
      "bandwidth": "Invoer Bandbreedte",
      "request": "Verzoeken",
      "page_views": "Pagina bezoeken per taal (afgelopen 30 dagen)",
      "multilingual_views": "Meertalige pagina bezoeken (afgelopen 30 dagen)",
      "most_page_viewed": "20 Meest bezochte pagina's (afgelopen 30 dagen)",
      "no_data_yet": "Er zijn nog geen gegevens beschikbaar",
      "th_language": "Taal",
      "th_page_views": "Pagina bezoeken",
      "real_visitors": "Echte bezoekers",
      "crawler": "Webcrawler"
    },
    "planHints": {
      "subscribeButton": "Abonneer",
      "upgradeButton": "Upgraden",
      "usedWords": "Je bent momenteel {words_used} woorden",
      "noPlan": "Er is geen plan geactiveerd voor dit domein. Abonneer je op een plan en begin met het vertalen van je website",
      "trialUsage": "U gebruikt momenteel {words_used} woorden van de {words_allowed} woorden die in het proefabonnement zijn opgenomen.",
      "trialEnds": "De proefperiode van de eerste maand is geactiveerd tot {trial_ends}.",
      "subscribeMessage": "Abonneer u voordat het klaar is om uw website vertaald te houden",
      "trialReachedLimit": "U heeft het maximale aantal vertaalde woorden voor de proefperiode bereikt.\nAbonneer u op een van onze plannen om door te gaan met het vertalen van uw website.",
      "paidUsage": "Je hebt {words_used} / {words_allowed} vertaalde woorden gebruikt in je plan.",
      "paidReachedLimit": "U heeft het maximale aantal vertaalde woorden voor het huidige plan bereikt.\nUpgrade uw abonnement om door te gaan met het vertalen van uw website-inhoud.",
      "trialOfferedUsage": "U gebruikt momenteel {words_used} woorden van de {words_allowed} woorden die zijn opgenomen in het proefabonnement. (Inclusief de {free_words} aangeboden woorden)",
      "paidOfferedUsage": "Je hebt {words_used} / {words_allowed} vertaalde woorden gebruikt in je plan. (Inclusief de {free_words} aangeboden woorden)",
      "noPlanExtra": "Let op: inactieve domeinen en hun gegevens worden regelmatig automatisch verwijderd.",
      "planRecommended": "Op basis van uw huidige vertaalvolume is het aanbevolen plan:",
      "planMaximumWords": "{{words}} woorden",
      "notHaveTranslatedWords": "U heeft nog geen vertaling gemaakt",
      "noPlanShopify": "Er is geen abonnement geactiveerd voor dit domein. Abonneer u op een abonnement in uw Shopify-dashboard en begin met het vertalen van uw website.",
      "subscribeMessageShopify": "Meld u aan via uw Shopify-dashboard voordat de vertaling is voltooid, zodat uw website vertaald blijft"
    },
    "translationSetup": {
      "kicker": "SUBDOMEININSTELLING",
      "title": "Vertaalinstellingen controleren",
      "description": "Controleer DNS, vertaalde hosts, toegang tot de oorspronkelijke site en accountlimieten.",
      "starting": "Controleren...",
      "button": "Instelling controleren",
      "viewLatest": "Laatste resultaat bekijken",
      "viewCurrent": "Huidige controle bekijken",
      "runAgain": "Opnieuw controleren",
      "viewDetails": "Details weergeven",
      "hideDetails": "Details verbergen",
      "error": "Kan de instelling niet controleren",
      "allPassed": "Alle controles geslaagd",
      "setupNeedsAttention": "Instelling vereist aandacht",
      "setupNeedsAttentionDescription": "Een of meer controles zijn mislukt. Bekijk de onderstaande punten of neem contact op met Linguise-ondersteuning.",
      "lastChecked": "Laatst gecontroleerd {{time}}",
      "domainOwnership": "Domeineigendom",
      "domainOwnershipDescription": "Verificatierecord gevonden",
      "domainOwnershipFailure": "Het DNS-record voor domeineigendom kon niet worden geverifieerd.",
      "translatedHosts": "Vertaalde hosts",
      "translatedHostsDescription": "{{count}} taalhosts gecontroleerd",
      "translatedHostsFailure": "Een of meer CNAME-records voor talen zijn onjuist.",
      "subdomainPage": "Subdomeinpagina",
      "subdomainPageDescription": "{{count}} vertaalde pagina’s accepteren HTTPS",
      "subdomainPageFailure": "TLS-verbinding mislukt bij het openen van een of meer vertaalde pagina’s.",
      "originalSite": "Oorspronkelijke site",
      "originalSiteDescription": "DNS-, TLS- en antwoordcontroles van de oorspronkelijke site",
      "originalSiteFailure": "DNS-, TLS- of antwoordcontrole van de oorspronkelijke site is mislukt.",
      "documentationAdvice": {
        "dns": "DNS-instelling bekijken",
        "tls": "HTTPS-instelling bekijken",
        "origin": "Instelling van oorspronkelijke site bekijken",
        "diagnostic": "Stappen voor probleemoplossing bekijken"
      },
      "evidence": {
        "originDns": "Oorspronkelijke DNS",
        "originTls": "Oorspronkelijke TLS",
        "originHttp": "Oorspronkelijk antwoord",
        "observedTargets": "Waargenomen doelen",
        "recordCount": "Records gevonden",
        "addressCount": "Adressen gevonden",
        "statusCode": "HTTP-status",
        "redirect": "Omleiding",
        "expiresAt": "Certificaat verloopt",
        "raw": "{{key}}",
        "noValue": "Geen waarde"
      },
      "checkerError": "Sommige controles konden niet worden voltooid.",
      "coreLocation": "Gecontroleerd vanuit {{location}}",
      "status": {
        "queued": "In wachtrij",
        "running": "Bezig",
        "completed": "Voltooid",
        "failed": "Mislukt",
        "passed": "Geslaagd",
        "warning": "Waarschuwing",
        "unknown": "Onbekend",
        "skipped": "Overgeslagen",
        "not_applicable": "Niet van toepassing"
      }
    },
    "throttling": {
      "title": "Vertaalbeperking",
      "description": "Tijdelijke gebruikslimieten",
      "unavailable": "Tijdelijke vertaalbeperkingen niet beschikbaar",
      "window": "{{used}} / {{max}} woorden",
      "resetsIn": "Wordt gereset over {{time}}",
      "throttled": "Vertaling tijdelijk gepauzeerd",
      "throttledDescription": "Een tijdelijke gebruikslimiet is bereikt. De vertaling wordt hervat zodra deze periode wordt gereset."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "STAP {{step}} UIT {{total}}",
      "doneLabel": "KLAAR, JE KUNT BEGINNEN MET VERTALEN!",
      "finish": {
        "title": "",
        "description": "Dit is de API-sleutel die je op je website moet gebruiken"
      },
      "instructions": "Installatie instructie",
      "domainSetting": "Domein instelling",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-script",
        "wizardWordpressStep1": "1. Installeer de",
        "wizardWordpressStep2": "\n 2. Kopieer en vul uw API-sleutel in de plug-ininstellingen \n",
        "wizardWordpressStep3": "3. Je bent klaar om te vertalen \n\n",
        "wizardWordpressStep4": "Voor een meer gedetailleerde instructie kun je een kijkje nemen in onze documentatie: ",
        "wizardJoomlaStep1": "1. Joomla pakket link: ",
        "wizardJoomlaStep2": "\n2. Kopieer en vul uw API-sleutel in de configuratie-instellingen van de extensie",
        "wizardJoomlaStep4": "\n 4. Je bent klaar om te vertalen\n\n",
        "wizardJoomlaStep3": "3. In de moduleconfiguratie stel je de talen in die je wilt weergeven, en voeg je je module in waar je hem nodig hebt.",
        "wizardPhpStep1": "1. Download ons php script en hier ",
        "wizardPhpStep2": "\n2. Volg hier de installatie-instructies op onze documentatiepagina ",
        "wizardPhpStep3": "\n3. Voeg de module toe aan uw pagina's.",
        "wizardPhpStep4": "\n Kopieer de volgende code en voeg deze toe aan de kop van uw html-pagina. De switchermodule wordt automatisch weergegeven\n",
        "dispatchStep1": "We hebben de vereiste gegevens succesvol naar de Linguise-plug-in verzonden. U kunt het volgende venster nu sluiten.",
        "dispatchStep2": "Mocht het token ontbreken wanneer u dit venster sluit, kopieer dan het volgende token:",
        "dispatchStep3": "U kunt dit fragment ook kopiëren om onze vlagwisselaar automatisch in te schakelen",
        "wizardOtherStep1": "Volg de onderstaande instructies om Linguise op uw domein te installeren.",
        "wizardOtherStep2": "Kopieer de volgende code en voeg deze toe aan de head van uw HTML-pagina. De switchermodule wordt dan automatisch weergegeven."
      },
      "trialAlreadyUsed": "Het lijkt erop dat je je gratis proefperiode al hebt gebruikt, dus je hebt een vertaalquotum nodig\nAbonneer u op een abonnement of neem contact met ons op als u uw proefperiode wilt verlengen.",
      "usefulLinks": "Nuttige links om te beginnen",
      "linkDocumentation": "Documentatie",
      "linkExtensionDl": "Extensie downloaden",
      "linkSubscribe": "Abonneer nu een plan",
      "linkDashboard": "Ga naar het dashboard",
      "exclusion": {
        "title": "Namen van bedrijven en producten",
        "description": ""
      },
      "finishButton": "Voltooi de opstelling",
      "subdomains": "Subdomeinen",
      "subdomain_setup": "Domein instellen",
      "subdomain_auto_setup": "Verbind uw DNS automatisch",
      "subdomain_manual_setup": "Zelf DNS-vermeldingen toevoegen",
      "subdomain_skip": "Zelf DNS-vermeldingen toevoegen",
      "auto_subdomains_info": "Het CMS van uw sitebouwer vereist een DNS-configuratie om talen per subdomein in te stellen (bijv. nl.domain.com). Dat kan automatisch via Entri. Klik gewoon op de knop \"Verbind uw DNS automatisch\" om verbinding te maken met uw DNS-manager en deze toe te voegen met Entri. ",
      "auto_subdomains_info_manual": "Of u kunt uw domein handmatig configureren door op de knop \"DNS-gegevens zelf toevoegen\" te klikken.",
      "auto_subdomains_info_2": "Dat kan automatisch via Entri. Klik gewoon op de knop \"Verbind uw DNS automatisch\" om verbinding te maken met uw DNS-manager en deze toe te voegen met Entri. ",
      "breadcrumbs": {
        "step1": "Stap 1: Domein, CMS en talen",
        "step2": "Stap 2: Taal-DNS",
        "step3": "Stap {{step}}: Installatie-instructies"
      }
    },
    "form": {
      "urls": {
        "dash": "Streepje -",
        "underscore": "Lage streep _",
        "title": "Vertaal URL's",
        "description": "Wil je vertalen in alle pagina's",
        "char_description": "Een teken om niet-geautoriseerde tekens in URL's te vervangen",
        "advertisement_title": "⚠ Je hebt veel talen ingesteld.\n",
        "advertisement": "Wij adviseren meestal om eerst te beginnen met het vertalen van websites met slechts enkele talen. Dan heb je een idee van het aantal woorden dat je website heeft. Het is ook beter voor SEO, want Google bots zullen sneller al je pagina's crawlen als je in het begin minder pagina's hebt. Na een week kun je nog een paar talen toevoegen en zo verder."
      },
      "url": {
        "title": "Url",
        "description": "Zet de URL van je hoofddomein beginnend met http:// of https://",
        "placeholder": "Domein URL",
        "advertisement_http": {
          "title": "Je gebruikt niet het https protocol",
          "description": "Controleer of je domein daadwerkelijk niet het https-protocol gebruikt, dat tegenwoordig wordt aanbevolen."
        },
        "advertisement_www": {
          "title": "Je subdomein is niet www",
          "description": "Meestal is het standaard subdomein www (zoals https://www.mydomain.com). Dit is misschien niet jouw geval, maar controleer goed of het domein dat je wilt toevoegen het juiste is."
        },
        "invalid_url": {
          "line1": "We hebben uw domein niet kunnen vinden. Controleer of uw domein openbaar toegankelijk is via internet en niet wordt omgeleid naar een andere locatie. ",
          "line2": "Als u zeker weet dat uw domein toegankelijk is, kunt u de domeinverificatie overslaan en nogmaals op de knop \"Volgende stap\" drukken",
          "contact": "U kunt in ieder geval contact met ons opnemen via",
          "force": "Domeinverificatie overslaan"
        },
        "invalid_subdomain_url": "Deze URL is niet toegestaan. Subdomeinen moeten de volgende vorm hebben: https://www.domain.tld of https://domain.tld zonder subdirectory."
      },
      "account": {
        "title": "Account",
        "description": "Selecteer een account om dit domein aan toe te wijzen",
        "placeholder": "Selecteer account...",
        "feedback": "Je moet een account kiezen"
      },
      "platform": {
        "title": "Platform",
        "description": "Selecteer uw websiteplatform op CMS-naam.",
        "learn": "Leer hoe u het kunt kiezen",
        "placeholder": "Zoek platform op CMS-naam...",
        "info": {
          "title": "⚠ Dit platform is onlangs toegevoegd.\n",
          "desc": "Dit websitebouwerplatform wordt ondersteund door Linguise, hoewel het onlangs is toegevoegd. Als u een probleem ondervindt, neem dan contact met ons op via de directe ondersteuningsmail:"
        },
        "description_read_only": "Het platform dat uw website gebruikt",
        "feedback": "Je moet een platform kiezen"
      },
      "language": {
        "title": "Taal",
        "description": "Selecteer de basistaal van je website",
        "placeholder": "Selecteer taal...",
        "feedback": "Je moet een taal kiezen",
        "description_read_only": "Basistaal van je website"
      },
      "token": {
        "title": "API-sleutel",
        "description": "Dit is de API Sleutel die je naar je website moet kopiëren",
        "copy": "Kopiëren naar klembord",
        "reset": "Reset API Sleutel",
        "reset_confirm": "Bevestig het resetten van de API-sleutel"
      },
      "languages": {
        "title": "Vertalen van talen",
        "description": "Selecteer de talen waarin je je website wilt laten vertalen",
        "placeholder": "Selecteer talen...",
        "feedback": "Je moet een taal kiezen"
      },
      "defaultRules": {
        "title": "Standaard regels",
        "description": "We hebben een reeks regels gedefinieerd die u moet gebruiken om de vertaling te verbeteren en te voorkomen dat ongewenste inhoud wordt vertaald, zoals het WordPress-dashboard.\nU kunt deze regels later verwijderen of bewerken als u dat wenst."
      },
      "disallow_deletion": "Je kunt geen domein met een actief abonnement verwijderen",
      "delete_confirm": "Bevestig het verwijderen van het domein",
      "delete": "Verwijder domein",
      "dynamic": {
        "title": "Vertaal dynamische inhoud",
        "description": "Dynamische inhoud gegenereerd door JavaScript en AJAX-verzoeken worden vertaald (deze optie verhoogt uw vertaalgebruik)"
      },
      "partial_translations": {
        "title": "Gedeeltelijke vertaling toestaan",
        "description": "Als uw account het vertaalquotum heeft bereikt, maar de pagina nog steeds moet worden vertaald, kan Linguise de pagina blijven weergeven met de inhoud die al is vertaald. Sommige delen van de pagina blijven echter onvertaald totdat u uw quotum opwaardeert. Hoewel een kleine hoeveelheid onvertaalde inhoud doorgaans geen schade toebrengt aan SEO, kan het toestaan ​​van te veel onvertaalde inhoud een negatieve invloed hebben op de gebruikerservaring. Om dit aan te pakken, kunt u een drempel instellen voor het percentage onvertaalde inhoud dat op een pagina is toegestaan. Als de onvertaalde inhoud deze drempel overschrijdt, worden gebruikers automatisch doorgestuurd naar de originele taalversie van de pagina.",
        "never": "Nooit"
      },
      "translate_error_pages": {
        "title": "Vertaal foutpagina's",
        "description": "Linguise kan alle foutpagina's vertalen, maar als uw foutpagina dynamische inhoud bevat, zoals een IP-adres of een verzoek-ID, moet u voorkomen dat u deze pagina's vertaalt.",
        "not_found_page": {
          "title": "Vertaal 404 pagina"
        },
        "error_page": {
          "title": "Vertaal andere foutpagina's"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Bestaand domein gevonden",
          "description": "Er is een bestaand domein gevonden voor deze gebruiker. Wilt u dit gebruiken?"
        }
      },
      "search_tl": {
        "title": "Zoek vertalingen",
        "description": "Schakel zoekvertalingen in voor uw websiteplatform (experimenteel, deze optie zal het gebruik van uw vertalingen vergroten)"
      },
      "shopify_promo": {
        "info": "Goed nieuws! We hebben nu een native Shopify-app die je kunt installeren vanuit de Shopify App Store.",
        "hyperlink": "Klik hier en installeer Linguise via de app.",
        "next_btn": "Ga naar je Shopify-winkel om de app te installeren.",
        "info_legacy": "Goed nieuws! We hebben nu een native Shopify-app die je kunt installeren vanuit de Shopify App Store.",
        "description_legacy": "Selecteer het platform \"Shopify\" in plaats van \"Shopify Legacy\"."
      },
      "wix_promo": {
        "info": "Goed nieuws! We hebben nu een native Wix-app die je kunt installeren vanuit de Wix App Market.",
        "hyperlink": "Klik hier en installeer Linguise via de app.",
        "next_btn": "Ga naar de Wix App Market om de app te installeren.",
        "info_legacy": "Goed nieuws! We hebben nu een native Wix-app die je kunt installeren vanuit de Wix App Market.",
        "description_legacy": "Selecteer het platform \"Wix\" in plaats van \"Wix Legacy\"."
      },
      "ai_disallow_deletion": "U kunt dit domein niet verwijderen zolang er nog een AI-quotum beschikbaar is. Neem contact op met onze supportafdeling als u dit domein wilt verwijderen.",
      "language_removal": {
        "card": {
          "title": "Vertalingen van verwijderde talen wissen",
          "description": "Deze talen zijn van je website verwijderd, maar de opgeslagen vertalingen tellen nog mee voor je tegoed. Wis ze om de woorden terug te krijgen.",
          "button": "Vertalingen wissen"
        },
        "hint": "De gebruikte woorden worden teruggezet in je tegoed. Je kunt dit per website eens per {{days}} dagen doen.",
        "modal": {
          "title": "Vertalingen wissen?",
          "intro": "Deze vertalingen worden definitief gewist:",
          "warning": "Dit kan niet ongedaan worden gemaakt. De gebruikte woorden worden teruggezet in je tegoed. Dit kan enkele minuten duren.",
          "limit": "Je kunt dit per website eens per {{days}} dagen doen.",
          "confirm": "Vertalingen wissen"
        },
        "scheduled": "De vertalingen worden gewist en je tegoed wordt binnenkort bijgewerkt.",
        "cooldown": "De vertalingen voor deze website zijn onlangs gewist. Je kunt ze op {{date}} opnieuw wissen.",
        "latest_completed": {
          "title": "Laatste voltooide verwijdering",
          "description": "Bekijk de verwijderde talen en de woorden die aan je tegoed zijn teruggegeven.",
          "languages": "Verwijderde talen",
          "words_returned": "Woorden teruggegeven aan je tegoed: {{words}}",
          "completed_at": "Voltooid op {{date}}"
        },
        "status": {
          "recent_title": "Recente verwijdering van vertalingen",
          "recent_description": "Volg de laatste verwijdering en bekijk wanneer je opnieuw kunt verwijderen.",
          "progress_title": "Voortgang van verwijderen",
          "loading": "Voortgang van verwijderen controleren...",
          "unavailable": "De voortgang kon niet worden geladen. Vernieuw de pagina en probeer het opnieuw.",
          "label": "Status",
          "pending": "In de wachtrij",
          "processing": "Bezig",
          "completed": "Voltooid",
          "failed": "Mislukt",
          "unknown": "Status niet beschikbaar",
          "percent": "{{percent}}% voltooid",
          "current_stage": "Huidige stap: {{stage}}",
          "processed": "{{processed}} records verwerkt",
          "processed_total": "{{processed}} van {{total}} records verwerkt",
          "requested_at": "Aangevraagd op {{date}}",
          "started_at": "Gestart op {{date}}",
          "completed_at": "Voltooid op {{date}}",
          "cooldown_period": "Je kunt dit per website eens per {{days}} dagen doen.",
          "cooldown_blocked": "Je kunt nog geen nieuwe verwijdering starten.",
          "stage": {
            "queued": "Wacht op de start",
            "processing": "Bezig",
            "refund_summary": "Teruggegeven woorden berekenen",
            "search_translations": "Zoekvertalingen verwijderen",
            "url_translations": "URL-vertalingen verwijderen",
            "translations": "Vertalingen verwijderen",
            "completed": "Voltooid",
            "failed": "Mislukt",
            "unknown": "Bezig"
          }
        },
        "forbidden": "Je hebt geen toestemming om vertalingen te verwijderen."
      }
    },
    "main": {
      "edit": "Wijzig domein",
      "add": "Voeg een domein toe",
      "wizard": "Welkom! New domain creation wizard",
      "common": "Domein"
    },
    "subdomains": {
      "config_ok": "Subdomeinen DNS is correct geconfigureerd.",
      "config_invalid": "Subdomeinen DNS vereist enige extra configuratie om te werken.",
      "config_check": "Subdomeinen DNS-configuratie wordt gecontroleerd, even geduld a.u.b....",
      "entri_timeout": "Entri meldde dat er een time-out is opgetreden bij het DNS-propagatieproces van uw subdomeinen. U moet het opnieuw proberen of u kunt het handmatig doen.",
      "entri_process": "Uw DNS is toegevoegd met Entri en het duurt meestal 10-30 minuten om deze door te geven (pas al uw taalsubdomeinen toe, zoals nl.domain.com). Als de DNS-validatie na 24 uur nog niet is voltooid, kunt u ons ondersteuningsteam bereiken: support@linguise.com ",
      "entri_ok": "DNS-propagatie is onderweg! Wachten op verspreiding... ",
      "infos": "U moet deze DNS-vermeldingen toevoegen aan uw DNS-domeinrecords om de vertaling te activeren. Klik op de vinkknop wanneer dit is gedaan. Het kan even duren voordat de DNS-records zijn doorgegeven, dus het kan zijn dat u na een paar minuten of uren terug moet komen.",
      "check": "Controleer de DNS-configuratie"
    },
    "notice": {
      "broken_card": "We kunnen uw abonnement voor {{url}} niet verlengen met de huidige betaalmethode. Update uw betaalkaart",
      "quota_reached": "Uw vertaalquotum voor {{url}} is bereikt. Voer een upgrade uit om uw websitevertaling te hervatten",
      "important": "Belangrijk",
      "quota_reached_button": "Upgrade nu uw abonnement",
      "broken_card_button": "Update uw betaalkaart",
      "ai_no_subscription": "AI-vertaling voor {{url}} vereist een actief abonnement of een actieve proefperiode. Zonder abonnement stopt het. Upgrade om door te gaan.",
      "ai_no_subscription_button": "Upgrade nu uw abonnement",
      "quota_warning": "Uw vertaalquotum voor {{url}} heeft {{throttling_used_percent}}% bereikt. Dit wordt over {{ttl}} gereset.",
      "locked": "Het domein {{url}} is momenteel vergrendeld voor migratie. U heeft nog steeds toegang tot uw site, maar u kunt geen nieuwe vertalingen bewerken of toevoegen!"
    },
    "subscription": {
      "next_payment_amount": "Aankomende kosten",
      "next_payment_date": "Volgende betaaldatum",
      "invoice": {
        "header": "Factuurgeschiedenis",
        "date": "Datum",
        "amount_due": "Hoeveelheid",
        "status": "Status",
        "actions": "Acties",
        "description": "Zodra transacties beschikbaar zijn, kunt u ze hier bekijken.",
        "status_text": {
          "draft": "Voorlopige versie",
          "open": "In behandeling",
          "paid": "Betaald",
          "uncollectible": "Oninbaar",
          "void": "Leegte",
          "failed": "Mislukt",
          "retrying": "Het opnieuw proberen"
        },
        "view": "Weergave",
        "empty": "Er zijn geen recente facturen gevonden voor dit abonnement",
        "retry_payment": "Opnieuw proberen"
      },
      "next_cancellation": "Annuleringsdatum",
      "cancel": "Abonnement opzeggen",
      "change_plan": "Plan wijzigen",
      "change": "Wijziging",
      "suspend": "Betaling opschorten",
      "resume": "Abonnement hervatten",
      "back": "Rug",
      "save": "Redden",
      "confirm_resume": "Weet u zeker dat u dit abonnement wilt hervatten?",
      "confirm_cancel": "Weet u zeker dat u dit abonnement wilt opzeggen?",
      "confirm_header": "Weet je het zeker?",
      "missing_status": "Dit abonnement ontbreekt",
      "not_found": "Geen abonnement gevonden voor dit domein",
      "no_payment_method": "Onbekend",
      "remove_billing": "Verwijderen",
      "confirm_manual_retry": "Weet u zeker dat u deze betaling opnieuw wilt proberen?",
      "shopify_maneged": "Dit abonnement wordt beheerd door Shopify. Beheer het via je Shopify-beheerpaneel.",
      "unknown_plan": "Onbekend abonnement"
    }
  },
  "domain_listing": {
    "add": "Website toevoegen",
    "select": "Kies een domein"
  },
  "editable": {
    "number": "nummer {{id}}"
  },
  "footer": {
    "about": "Over",
    "support": "Steun"
  },
  "frontendEditor": {
    "main": "Live-editor",
    "description": "De Live Editor helpt je om de vertalingen in je website direct te bewerken.",
    "button": "Live-editor openen",
    "language_selection": "Taalkeuze voor vertaling",
    "video_label": "Leer hoe u de live-editor gebruikt"
  },
  "general": {
    "403": {
      "tab_title": "Oeps - 403-fout",
      "title": "Toegang geweigerd",
      "message": "Het lijkt erop dat je geen toegang hebt tot de gevraagde pagina.",
      "home": "Terug naar Huis"
    },
    "404": {
      "tab_title": "Oeps - 404-fout",
      "title": "Pagina niet gevonden",
      "message": "Het lijkt erop dat je een verkeerde afslag hebt genomen. Maak je geen zorgen... het overkomt de besten onder ons. Hier is een kleine tip om je weer op weg te helpen.",
      "home": "Terug naar Huis"
    },
    "500": {
      "tab_title": "500 Fout",
      "title": "Interne Server Fout",
      "message": "Probeer eens je pagina te verversen of neem contact met ons op",
      "home": "Terug naar Huis"
    },
    "fields": {
      "alert": "Sommige velden zijn niet geldig, corrigeer de ongeldige velden.",
      "invalid": "Dit veld is ongeldig",
      "phone_re": "Telefoonnummer is ongeldig",
      "phone_invalid": "Het telefoonnummer is ongeldig",
      "email": "Het e-mailveld is ongeldig."
    },
    "saving": "Opslaan ...",
    "save": "Opslaan",
    "save_and_quit": "Opslaan en afsluiten",
    "invite": "Uitnodigen",
    "cancel": "Annuleer",
    "yes": "Ja",
    "no": "Nee",
    "nextStep": "Volgende stap",
    "loading": "Een ogenblik geduld alsjeblieft, de toepassing wordt geladen",
    "goback": "Ga terug",
    "manage": "Beheer",
    "delete": "Verwijder",
    "deleting": "Verwijderen ...",
    "table": {
      "no_data": "Er zijn hier nog geen gegevens..."
    },
    "confirm": "Bevestigen",
    "unknown": "Onbekend",
    "hide": "Verbergen",
    "show": "Tonen",
    "on": "Op",
    "off": "Uit",
    "default": "Standaard"
  },
  "home": {
    "header": "Huis",
    "manage": "Abonnement beheren",
    "activate_now": "Activeer nu",
    "activate_plan_now": "Abonneer nu",
    "upgrade_plan_now": "Upgradeplan nu",
    "trial_message_part_1": "Je hebt momenteel een proefabonnement. ",
    "trial_message_part_2": "Je kunt op elk moment een lidmaatschap activeren.",
    "add": "Domein toevoegen",
    "table": {
      "title": "Domeinen",
      "description": "Lijst met uw domeinen, klik op het domein om de vertalingen te beheren"
    },
    "domains": {
      "empty": "Je hebt geen domeinen op dit account"
    },
    "accountsList": {
      "title": "Accounts",
      "add": "Nieuw account toevoegen",
      "name": "Account naam"
    },
    "update_credit_card": "Creditkaart Gegevens bijwerken",
    "canceled": "Abonnement opgezegd",
    "cancelling_subs": "Annuleren om {{0}}",
    "resume_subscription": "Abonnement hervatten",
    "shopify_managed": "Beheerd door Shopify",
    "trial_ends_at": "Eindigt om {{0}}",
    "free_trial": "Gratis proefperiode",
    "no_subs": "Geen actief abonnement"
  },
  "invoices": {
    "title": "Facturen",
    "list": {
      "title": "Facturenlijst"
    },
    "table": {
      "customer": "Klant",
      "domain": "Domein",
      "amountPaid": "Betaald bedrag",
      "status": "Toestand",
      "date": "Datum",
      "invoice": "Factuur",
      "pay": "Factuur betalen",
      "actions": "Acties",
      "deleted_domain": "Domein verwijderd",
      "plan_name": "Plan",
      "action": "Actie"
    },
    "listPending": {
      "title": "Lijst met openstaande facturen"
    }
  },
  "language_settings": {
    "display": "Weergave van de taallijst",
    "position": "Positie",
    "display_help_text": "Geef vlag- en/of taalnamen weer. De standaardpositie van de taalwisselaar kan overal in de inhoud zijn of op een vaste positie die vast blijft of beweegt tijdens het scrollen",
    "side_by_side": "Zij aan zij",
    "dropdown": "Laten vallen",
    "popup": "Pop-up",
    "flag": "Vlag",
    "lang_name": "Taal naam",
    "lang_short_name": "Korte namen",
    "positions": {
      "in_place": "In situ",
      "top_left": "Linksboven",
      "top_left_no_scroll": "Linksboven (no-scroll)",
      "top_right": "Rechtsboven",
      "top_right_no_scroll": "Rechtsboven (no-scroll)",
      "bottom_left": "Linksonder",
      "bottom_left_no_scroll": "Linksonder (no-scroll)",
      "bottom_right": "Rechts onder",
      "bottom_right_no_scroll": "Rechtsonder (no-scroll)"
    },
    "lang_names_display": {
      "title": "Taalnamen worden weergegeven",
      "help_text": "Geef in de taalwisselaar de taalnamen weer in het Engels of in de oorspronkelijke taal, d.w.z. Frans of Frans",
      "english": "Engels",
      "native_languages": "Moedertalen"
    },
    "flag_shape": {
      "title": "Vlag stijl",
      "help_text": "Gebruik ronde svg- of rechthoekige svg-vlagpictogrammen",
      "round": "Ronde",
      "rectangular": "Rechthoekig"
    },
    "english_flag_type": {
      "title": "Engels vlagtype",
      "help_text": "Gebruik de vlag van Groot-Brittannië of de VS voor Engels",
      "usa": "Amerikaanse vlag",
      "great_britain": "De vlag van Groot-Brittannië"
    },
    "german_flag_type": {
      "title": "Type Duitse vlag",
      "help_text": "Gebruik de Oostenrijkse of Duitse vlag voor Duits",
      "german": "Duitse vlag",
      "austria": "Oostenrijkse vlag"
    },
    "spain_flag_type": {
      "title": "Soort Spaanse vlag",
      "help_text": "Gebruik de Mexicaanse of Spaanse vlag voor Spaans",
      "spanish": "Spaanse vlag",
      "mexico": "Vlag van Mexico",
      "peruvian": "Peruviaanse vlag"
    },
    "portugal_flag_type": {
      "title": "Portugees vlagtype",
      "help_text": "Gebruik de Portugese of Braziliaanse vlag voor Portugees",
      "portugal": "Portugese vlag",
      "brazil": "Braziliaanse vlag"
    },
    "taiwanese_flag_type": {
      "title": "Taiwanees vlagtype",
      "help_text": "Gebruik de Taiwanese of Chinese vlag voor Taiwanees",
      "taiwanese": "Taiwanese vlag",
      "chinese": "Chinese vlag"
    },
    "flag_border_radius": {
      "title": "Vlagrandradius (px)",
      "help_text": "Als u de rechthoekige vlagvorm gebruikt, kunt u een aangepaste randradius in pixels toepassen"
    },
    "flag_width": {
      "title": "Vlaggrootte (px)",
      "help_text": "Selecteer vlaggengrootte in pixels. Dat verandert niets aan het gewicht van de afbeelding, aangezien het een .svg-indeling is"
    },
    "lang_color": {
      "color_title": "Taalnaam kleur",
      "color_help_text": "Selecteer een standaard tekstkleur voor uw taalnamen",
      "hover_color_title": "Zweefkleur voor taalnaam",
      "hover_color_help_text": "Selecteer een muisaanwijzertekstkleur voor uw taalnamen",
      "color_popup_title": "Kleur pop-uptaal",
      "color_popup_help_text": "Kleur van de taaltitel in de pop-up of in de vervolgkeuzelijsten",
      "hover_color_popup_title": "Zweefkleur voor pop-uptaal",
      "hover_color_popup_help_text": "Selecteer een muisaanwijzertekstkleur van de taaltitel in de pop-up of in de vervolgkeuzelijsten"
    },
    "flag_box_shadow": {
      "shadow_title": "Vlaggendoos schaduw",
      "shadow_help_text": "Kleur- en schaduwgrootte voor uw taalvlaggen",
      "hover_shadow_title": "Vlaggendoosschaduw bij aanwijzen",
      "hover_shadow_help_text": "Kleur- en schaduwgrootte voor uw taalvlaggen bij muisaanwijzer",
      "shadow_h_offset": "Schaduw H-offset (px)",
      "shadow_v_offset": "Schaduw V-verschuiving (px)",
      "shadow_blur": "Schaduwvervaging (px)",
      "shadow_spread": "Schaduwspreiding (px)",
      "shadow_color": "Schaduw kleur"
    },
    "order": "Taalvolgorde",
    "language_order_help": "De volgorde van de taal die wordt weergegeven in de taalwisselaar. U kunt de taal slepen en neerzetten om ze opnieuw te ordenen. ",
    "order_reset": "Bestelling opnieuw instellen",
    "language_order_dragdrop": "U kunt de taal slepen en neerzetten om ze opnieuw te ordenen.",
    "popup_lang_name": "Popuptaalnaam",
    "preview": "Taalvoorbeeld"
  },
  "link": {
    "form": {
      "original": {
        "title": "Originele bron",
        "description": "Voeg uw originele link-URL toe en vervang deze hieronder door taal om ze te vertalen",
        "srcset_description": "Je bewerkt een afbeeldings-URL. Zorg ervoor dat u de documentatie leest, vooral als u srcset gebruikt of niet weet wat het is",
        "link": "Koppeling",
        "match_link": "Match-modus",
        "match_exact": "Exact",
        "match_wildcard": "Jokerteken",
        "match_regex": "Reguliere expressie"
      },
      "alternative_languages": {
        "title": "Koppelingen om te vervangen",
        "description": "Vervang medialinks en externe links op al uw pagina's, per taal...",
        "link": "Koppeling om te vervangen"
      },
      "error": {
        "atLeastOne": "Voeg ten minste één vertaling toe.",
        "url": "De URL is ongeldig",
        "extension": "De link moet een extensie hebben, maar deze mag niet .html of .php zijn. En de link mag geen taalpad bevatten, b.v. \"/fr\"",
        "regex": "De regex is ongeldig",
        "wildcard": "De wildcard-link heeft een ongeldig protocol"
      }
    },
    "main": {
      "parent": "Koppelingen",
      "edit": "Koppeling bewerken"
    }
  },
  "links": {
    "title": "Beheer van media en externe links",
    "description": "Vermeld en bewerk uw website Medialinks of externe links.",
    "add": "Voeg een link toe",
    "delete": "Koppeling verwijderen",
    "table": {
      "original": "Origineel",
      "language": "Taal",
      "translation": "Vertaling",
      "action": "Actie",
      "delete_confirm": "Bevestig het verwijderen van de link"
    }
  },
  "members": {
    "header": "Leden",
    "invite": "Een nieuw lid uitnodigen",
    "modal": {
      "inviteHeader": "Een nieuw lid uitnodigen",
      "editHeader": "Wijzig lid",
      "detachHeader": "Lid loskoppelen",
      "detachBody": "Weet je zeker dat je dit lid van dit account wilt loskoppelen?",
      "selfDetachBody": "Weet u zeker dat u zich wilt losmaken van dit accountbeheer? Daarna heeft u geen toegang meer tot de gegevens met betrekking tot dit account. "
    },
    "table": {
      "title": "Ledenlijst",
      "description": "Leden rollen en domeinen toegang",
      "name": "Naam",
      "email": "E-mail",
      "websites": "Websites",
      "languages": "Talen",
      "role": "Rol",
      "status": "Toestand",
      "resendInvite": "opnieuw verzenden",
      "inviteSent": "uitnodiging is verstuurd",
      "actions": "Acties",
      "edit": "Wijzig",
      "detach": "Loskoppelen",
      "empty": "Je hebt nog geen leden",
      "all_website": "Alle websites en talen",
      "roles": {
        "admin": "Beheerder",
        "manager": "Manager",
        "translator": "Vertaler"
      },
      "statuses": {
        "pending": "In afwachting",
        "accepted": "Geaccepteerd",
        "declined": "Afgewezen"
      }
    },
    "errors": {
      "role": "Je moet een rol kiezen",
      "domains": "Je moet minstens 1 website kiezen voor de geselecteerde rol",
      "languages": "Je moet minstens 1 taal kiezen voor de geselecteerde websites"
    },
    "inviteSent": "Je uitnodiging is succesvol verzonden"
  },
  "pagination": {
    "showing": "{{limit}} van {{total}} resultaten worden getoond",
    "showing_only_count": "{{limit}} resultaten worden getoond"
  },
  "payments_method": {
    "header": "Betaalmethoden",
    "table": {
      "title": "Lijst met betalingsmethoden",
      "description": "Bijgevoegde betaalmethoden aan uw account",
      "default": "Standaard",
      "action_edit_remove": "Bewerken of verwijderen",
      "action_remove": "Verwijderen",
      "action_default": "Als standaard instellen",
      "action_fallback": "Instellen als fallback",
      "expires": "Verloopt",
      "add_new_card": "Betaalmethode toevoegen",
      "action_fallback_remove": "Verwijderen uit terugval",
      "fallback": "Terugval",
      "action_edit": "Bewerking",
      "action_delete": "Verwijderen",
      "action_default_remove": "Verwijderen als standaard",
      "domain_count@@one": "Gebruikt door {{count}} domeinen",
      "domain_count@@other": "Gebruikt door {{count}} domeinen"
    },
    "paypal_bind": {
      "button": "PayPal-account koppelen",
      "button_load": "Verbinden...",
      "disconnected": "Niet verbonden",
      "error": "Er is een fout opgetreden",
      "success_header": "Succes",
      "success_no_promo": "Uw PayPal-account is nu verbonden",
      "success": "Uw PayPal-account is nu verbonden, er wordt € 5 afgetrokken van uw volgende factuur!"
    },
    "card_add": {
      "header": "Nieuwe kaart toevoegen",
      "success": "Nieuwe kaart aan Linguise gekoppeld!",
      "terms": "Door uw kaartgegevens te verstrekken, geeft u Linguise toestemming om toekomstige betalingen van uw kaart af te schrijven volgens onze servicevoorwaarden."
    },
    "card_detail": {
      "header": "Kaartinformatie",
      "delete": {
        "error": "U kunt deze betaalmethode niet verwijderen omdat deze een actief abonnement heeft!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonnementen op deze betaalmethode",
        "header_domain": "Domein",
        "header_plan": "Plan",
        "header_status": "Status",
        "header_actions": "Acties",
        "cancelling": "Annuleren om: {{0}}",
        "next_payment": "Volgende betaling op: {{0}}",
        "action_renew": "Vernieuwen",
        "no_subs_header": "Er zijn geen abonnementen om te tonen",
        "no_subs_desc": "Zodra u zich op deze kaart abonneert, wordt alle informatie hier weergegeven",
        "action_manage": "Beheren"
      },
      "status": {
        "active": "Actief",
        "canceled": "Geannuleerd",
        "incomplete": "Onbetaald",
        "incomplete_expired": "Onbetaald (verlopen)",
        "past_due": "Achterstallig",
        "trialing": "Proces",
        "unpaid": "Onbetaald",
        "missing": "Fout"
      }
    },
    "delete_confirm_body": "Weet u zeker dat u deze betaalmethode wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt!",
    "delete_confirm_header": "Betaalmethode verwijderen?",
    "card_edit": {
      "header": "Kaart bewerken",
      "billing_header": "Factureringsgegevens",
      "address_error": "Adres is vereist!",
      "card_number": "Kaartnummer",
      "card_expiry": "Vervaldatum",
      "expiry_error_month": "Ongeldige maand opgegeven",
      "expiry_error_year": "Ongeldig jaar opgegeven",
      "expiry_error_expired": "Het vervaljaar van uw kaart ligt in het verleden.",
      "card_header": "Kaartinformatie",
      "expiry_error_empty": "Dit veld is verplicht!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "vertaalde woorden",
    "current": "Huidige",
    "archived": "Gearchiveerd",
    "day": "dag",
    "week": "week",
    "month": "Maand",
    "year": "Jaar",
    "activate": "Activeer",
    "cancel": "Annuleer",
    "change": "Verander",
    "upgrade": "Upgraden",
    "downgrade": "Downgraden",
    "notEnoughWords": "Te weinig woorden",
    "yearIntervalOnly": "Kan niet overstappen van jaarplan",
    "wordsUnlimited": "Onbeperkte woorden",
    "tabs": {
      "day": "Dagelijkse prijzen",
      "week": "Wekelijkse prijzen",
      "month": "Maandelijkse prijzen",
      "year": "Jaarprijzen",
      "sub_texts": {
        "day": "Eén vaste prijs, elke dag",
        "week": "Eén vaste prijs, elke week",
        "month": "Eén vaste prijs, elke maand",
        "year": "Eén maand gratis, één factuur per jaar"
      }
    },
    "details": {
      "new_languages": "Voeg op elk moment nieuwe talen toe",
      "one_month_trial": "Gratis proefperiode van één maand voor elke nieuwe website",
      "multi_content_indexed": "100% van de meertalige inhoud geïndexeerd",
      "translate_new_content": "Vertaal nieuwe inhoud onmiddellijk",
      "free_installation": "Gratis installatie en configuratie",
      "compared_monthly_plan": "Eén maand gratis vergeleken met maandelijkse abonnementen",
      "risk_free_recurring": "Risicovrij terugkerende mislukte betalingen",
      "unlimited_languages": "Onbeperkte talen en paginaweergaven",
      "high_server_resources": "Hoge serverbronnen",
      "billed": {
        "day": "Dagelijks gefactureerd",
        "week": "Wekelijks gefactureerd",
        "month": "Maandelijks gefactureerd",
        "year": "Jaarlijks gefactureerd"
      },
      "request_max_size": "Maximale aanvraaggrootte van {{0}}"
    },
    "frequent_question": {
      "title": "Veelgestelde vragen",
      "questions": {
        "trial": {
          "question": "Kan ik de proefversie gebruiken op een nieuw websitedomein?",
          "answer": "Ja, we bieden een gratis proefperiode van 30 dagen aan voor elk nieuw websitedomein dat u aan uw account toevoegt. Zo kunt u de vertaalservice volledig testen op uw nieuwe website."
        },
        "seo": {
          "question": "Hoeveel tijd kost het voordat mijn SEO verbetert?",
          "answer": "Inhoud en meertalige inhoud hebben tijd nodig om volledig geïndexeerd en goed gerangschikt te zijn. Afhankelijk van het verkeer en de grootte van uw website bedraagt dit tussen de 3 en 6 weken."
        },
        "quota": {
          "question": "Zijn de menselijke vertalingen opgenomen in de quota?",
          "answer": "Nee, de limiet voor het aantal woorden geldt alleen voor automatische machinevertalingen. Een vertaler kan automatische vertalingen zonder beperking handmatig bewerken."
        }
      }
    },
    "best_offer": "Beste aanbieding",
    "resume": "Cv",
    "subsCanceled": "Er is nog een abonnementsopzegging in behandeling",
    "period": {
      "days@@one": "dag",
      "days@@other": "{{count}} dagen",
      "hours@@one": "uur",
      "hours@@other": "{{count}} uren",
      "minutes@@one": "minuut",
      "minutes@@other": "{{count}} minuten",
      "seconds@@one": "seconde",
      "seconds@@other": "{{count}} seconden"
    },
    "words": {
      "billion": "{{value}} mld.",
      "million": "{{value}} mln.",
      "thousand": "{{value}} k"
    },
    "throttling_info": "{{words}} woorden per {{period}}"
  },
  "profile": {
    "welcome": "Welkom!",
    "account": "Mijn Account",
    "subscriptions": "Abonnementen",
    "logout": "Uitloggen"
  },
  "register": {
    "errors": {
      "password": "Minimaal 8 tekens, ieder teken"
    }
  },
  "route": {
    "dashboard": "Dashboard",
    "rules": "Regels",
    "translations": "Vertalingen",
    "search_translations": "Zoek Queries",
    "urls_translations": "Urls Vertalingen",
    "links": "Media en externe links",
    "online_editor": "Live-editor",
    "settings": "Instellingen",
    "domain": {
      "finish": "Instellingen",
      "preconfig": "Instellingen"
    },
    "home": "Huis",
    "domain_list": "Domeinlijst",
    "members": "Leden",
    "invoices": "Facturen",
    "billing": "Factuurgegevens",
    "language_display": "Taalvlaggen worden weergegeven",
    "payment_methods": "Betaalmethoden",
    "ai_translation": "AI-vertaling",
    "ai_translation_settings": "Instellingen",
    "ai_translation_pricing": "Prijzen"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Te negeren tekst",
        "add": "Nieuwe toevoegen",
        "title": "Te negeren tekst",
        "description": "Voeg één of meerdere teksten toe om te negeren",
        "ignore_case": "Negeer geval"
      },
      "html_content": {
        "title": "Toepassen op html-inhoud",
        "description": "Regel toepassen over je gehele inhoud of door een specifieke CSS selector te kiezen",
        "all_page": "Alle pagina's",
        "css_selector": "CSS selecteur",
        "label": "CSS selecteur",
        "placeholder": "Selector om toe te passen op",
        "add": "Nieuwe toevoegen"
      },
      "apply_to_urls": {
        "title": "Toepassen op URL's",
        "description": "Selecteer specifieke URL's waarop je de regel wilt toepassen",
        "all_urls": "Alle URL's",
        "selected_urls": "Geselecteerde URL's",
        "label": "Url om aan te vragen",
        "placeholder": "Url om aan te vragen",
        "original_url": "Originele URL's",
        "translated_url": "Vertaalde URL",
        "wildcard": "Jokerteken",
        "regex": "Reguliere uitdrukking",
        "add": "Nieuwe toevoegen",
        "expression": "Soort uitdrukking"
      },
      "apply_urls": {
        "title_exclude": "Uitsluiten in URL's",
        "title_replace": "Vervangen in URL's",
        "title_description": "Pas deze regel ook toe op de vertaling van URL's"
      },
      "apply_languages": {
        "title": "Toepassen op talen",
        "description": "Selecteer een specifieke taal waar je de regel wilt toepassen",
        "all_languages": "Alle talen",
        "selected_languages": "Geselecteerde talen",
        "placeholder": "Selecteer talen...",
        "feedback": "Je moet een taal kiezen"
      },
      "name": {
        "title": "Titel",
        "description": "Geef je regel voor het gemak een titel",
        "placeholder": "Regelnaam"
      },
      "type": {
        "title": "Type",
        "description": "Kies het type regel dat je wilt toevoegen",
        "text_ignore": "Tekst negeren",
        "text_replace": "Tekst vervangen",
        "content_exclusion": "Inhoudelijke uitsluiting",
        "url_exclusion": "Uitsluiting door URL",
        "ignore_inline": "Inline negeren",
        "full_description": {
          "text_ignore": "Voeg regels toe om te voorkomen dat bepaalde teksten vertaald worden. Het kan gaan om je productnaam, merknaam of andere technische elementen waarvan je niet wilt dat ze vertaald worden.",
          "text_replace": "Tekst vervangen maakt het mogelijk om bepaalde tekst te vervangen door de vertaling die je wilt; dit kan nodig zijn als de vertaling de context negeert.",
          "content_exclusion": "Uitsluiting van inhoud helpt u de vertaling van bepaalde inhoud op de pagina te voorkomen.\n  Als u een pagina volledig wilt uitsluiten van vertaling (helemaal geen meertalige URL voor deze pagina en geen vertaalde inhoud), gebruik dan het type 'Uitsluiting op basis van URL'",
          "url_exclusion": "Met uitsluiting van vertalingen kun je de pagina's instellen die je niet wilt vertalen.",
          "ignore_inline": "Vermijd het vertalen van bepaalde inhoud als inline-inhoud, vertaal in plaats daarvan elke tag afzonderlijk."
        }
      },
      "text_replace": {
        "title": "Te vervangen tekst",
        "description": "Vervang sommige teksten door jouw specifieke vertaling. Vervang elke tekst op al je pagina's, per taal...",
        "text_to_replace": "Te vervangen tekst",
        "ignore_case": "Negeer zaak",
        "text_type": "Vervanging in de vertaling",
        "text_type_original": "Origineel",
        "text_type_translation": "Vertaling",
        "keep_case": "Probeer de zaak te houden",
        "add": "Nieuwe toevoegen"
      },
      "content_exclusion": {
        "title": "Inhoudelijke uitsluiting",
        "description": "Selecteer een of meer CSS-selectoren die niet worden vertaald",
        "label": "CSS selecteur",
        "placeholder": "Selecteur om toe te passen op",
        "add": "Nieuwe toevoegen"
      },
      "multilingual_url": {
        "title": "Gebruik meertalige URL",
        "description": "Indien ingesteld op Ja, wordt de URL NIET vertaald, maar blijft de pagina meertalig met een vertaalde inhoud.",
        "live_example_title": "Live voorbeeld",
        "live_example_description": "URL bron: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL bron: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Gegenereerde URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Pas de regel toe op statische inhoud of dynamische inhoud of beide",
        "title": "Van toepassing zijn op inhoud",
        "all": "Alle inhoud",
        "static": "Statische inhoud",
        "dynamic": "Dynamische inhoud"
      },
      "force_apply_urls": {
        "title_description": "Force Pas deze regel toe op alle vertaling van URL's, inclusief bestaande vertalingen!",
        "title_replace": "Force vervangen in URL's",
        "title_exclude": "Force sluit uit in URL's",
        "warning": "Waarschuwing",
        "warning_part1": "Dit instellen op \"ja\" kan uw website -URL -vertalingen breken.",
        "warning_part2": "Dit kan tijdelijk of permanent een 404s -pagina genereren, ga alleen verder als u de gevolgen begrijpt.",
        "warning_replacement_original": "Aanvullende waarschuwing: u probeert de oorspronkelijke inhoud te vervangen die van invloed kan zijn op de URL, de vertaling kan mislukken, omdat Linguise niet in staat is om de originele URL's goed te vinden"
      }
    },
    "main": {
      "parent": "Regels",
      "edit": "Regel bewerken",
      "add": "Nieuwe regel"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" wordt genegeerd in de inhoud en in de URL",
      "preview_single": "\"{{text_ignore}}\" zal in de inhoud worden genegeerd",
      "preview_more_with_url": "\"{{text_ignore}}\" en {{count}} meer zal in de inhoud worden genegeerd",
      "preview_more": "\"{{text_ignore}}\" en {{count}} meer zal in de inhoud worden genegeerd",
      "other_parameters": "Voor deze regel zijn andere parameters ingesteld, klik op de bewerkingsknop voor meer informatie."
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" is vervangen door \"{{replacement}}\"in de inhoud en de URL's",
      "preview_single": "\"{{original}}\" is vervangen door \"{{replacement}}\" in de inhoud",
      "preview_more_with_url": "\"{{original}}\" is vervangen door \"{{replacement}}\" in de content en de URL's, en {{nb}} meer",
      "preview_more": "\"{{original}}\" is vervangen door\"{{replacement}}\" in de inhoud, en {{nb}} meer",
      "other_parameters": "Voor deze regel zijn andere parameters ingesteld, klik op de bewerkingsknop voor meer informatie."
    },
    "content_exclusion": {
      "selectors": "{{nb}}CSS selector(en) uitgesloten van de vertaling",
      "other_parameters": "Voor deze regel zijn andere parameters ingesteld, klik op de bewerkingsknop voor meer informatie."
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}}URL's worden uitgesloten van de vertaling, maar behouden toch het meertalige voorvoegsel",
      "some": "{{nb}}URL's worden volledig uitgesloten van de vertaling",
      "all_multilingual": "alle URL's worden uitgesloten van de vertaling, maar behouden toch het meertalige voorvoegsel",
      "all": "alle URL's worden volledig uitgesloten van de vertaling",
      "other_parameters": "Voor deze regel zijn andere parameters ingesteld, klik op de bewerkingsknop voor meer informatie."
    },
    "ignore_inline": {
      "elements": "Alle inline-inhoud wordt vertaald als blok-inhoud in de pagina",
      "all_elements": "Sommige inline-inhoud wordt vertaald als blok-inhoud in de pagina",
      "other_parameters": "Er zijn nog andere parameters ingesteld voor deze regel. Klik op de knop 'Bewerken' voor meer informatie."
    },
    "title": "Beheer van de regels",
    "description": "Beheer de uitsluitingen en vervangingen van je vertalingen over je hele website",
    "add": "Nieuwe regel toevoegen",
    "table": {
      "title": "Titel",
      "type": "Type",
      "preview": "Regel preview",
      "action": "Actie",
      "delete_confirm": "Bevestig het verwijderen van de regel",
      "types": {
        "text_ignore": "Tekst negeren",
        "text_replace": "Tekst vervangen",
        "content_exclusion": "Inhoudelijke uitsluiting",
        "url_exclusion": "Url uitsluiting",
        "ignore_inline": "Negeer inline",
        "unknown": "Onbekende regel"
      },
      "no_data": "Hier zijn nog geen regels"
    },
    "apply_on_content": {
      "static": "Deze regel is alleen van toepassing op statische content.",
      "dynamic": "Deze regel wordt alleen toegepast op dynamische content."
    }
  },
  "search_translations": {
    "title": "Beheer van queries",
    "description": "Lijst van al je gebruikte website vertalingen door middel van zoekformulieren (Van vertaalde taal naar de basistaal van je domein)",
    "filter_languages": "Filter op talen...",
    "filter_original": "Filter tekst in originele taal",
    "filter_translation": "Filter op vertaalde tekst",
    "table": {
      "original": "Origineel",
      "language": "Taal",
      "translation": "Vertaling"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Abonneren is niet gelukt!",
      "title": "Abonneren is niet gelukt!",
      "subtitle": "Er is een fout opgetreden bij het verwerken van uw abonnement.",
      "home": "Ga terug naar huis",
      "generic": "Er is een onbekende fout opgetreden aan de taalzijde. Neem contact op met de beheerder!"
    },
    "success": {
      "home": "Beheer domeinvertalingen",
      "message": "Wij doen er alles aan om u de best mogelijke vertaalervaring te bieden. Ons team van experts staat klaar om u te helpen met al uw vragen of ondersteuning die u nodig heeft. Om te beginnen, klikt u eenvoudig op de onderstaande knop.",
      "subtitle": "Bedankt dat u voor de vertaalservice Linguise hebt gekozen",
      "title": "Abonnement geactiveerd!",
      "tab_title": "Bedankt voor het abonnement!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Abonnement beheren"
    },
    "list": {
      "title": "Abonnementenlijst",
      "description": "Lijst van je domein abonnementen"
    },
    "table": {
      "domain": "Domein",
      "plan": "Plan",
      "status": "Toestand",
      "card": "Kaart",
      "usage": "Gebruik",
      "actions": "Acties",
      "payment_method": "Betaalmethode"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} woorden",
      "paidOffered": "{{words_used}} / {{words_allowed}} woorden\n(Inclusief {{free_words}} gratis aangeboden woorden)"
    },
    "success": {
      "tab_title": "Abonnement geactiveerd!",
      "title": "Abonnement geactiveerd!",
      "subtitle": "Bedankt dat u voor de vertaalservice Linguise hebt gekozen",
      "message": "'Wij doen er alles aan om u de best mogelijke vertaalervaring te bieden. Ons team van experts staat klaar om u te helpen met al uw vragen of ondersteuning die u nodig heeft. Om te beginnen, klikt u eenvoudig op de onderstaande knop.",
      "home": "Beheer domeinvertalingen"
    },
    "popup": {
      "dueToday": "Totaal vandaag verschuldigd",
      "nextPeriod": "Vanaf {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Kies een account"
    }
  },
  "translation": {
    "main": {
      "parent": "Vertalingen",
      "edit": "Vertaling bewerken"
    },
    "form": {
      "original": {
        "title": "Origineel in {{language}}"
      },
      "is_inline": "Deze vertaling is gemaakt van inline-inhoud.",
      "inline_editor": {
        "count_warning": "Het aantal inlinegebieden komt niet overeen met het origineel ({{current}} van {{expected}}).",
        "restore_original": "Originele tekst herstellen",
        "insert_placeholder": "Plaatshouder invoegen",
        "drag": "Sleep om het inlinegebied te verplaatsen",
        "area": "Inline-gebied {{index}}",
        "restore": "Ontbrekende inlinegebieden herstellen"
      },
      "translation": {
        "title": "Vertaling in {{language}}",
        "description": "Vertaling die je wilt overschrijven"
      }
    },
    "copy": {
      "title": "Kopiëren naar de handmatige vertaling",
      "label": "Kopiëren naar handmatig"
    },
    "level": {
      "base": {
        "title": "Basisvertaling",
        "subtitle": "Automatisch · Linguise Cloud-vertaling",
        "empty": "Geen basisvertaling voor deze tekst.",
        "overridden": "Uw keuze is opgeslagen, maar in plaats daarvan wordt de nieuwste AI-verbeterde vertaling getoond omdat “Handmatige en geselecteerde vertalingen overschrijven” op Ja staat in de AI-vertaalinstellingen. Schakel die instelling uit om uw keuze te gebruiken."
      },
      "not_generated": "Niet gegenereerd",
      "none": "Nog niets",
      "ai": {
        "title": "AI-verbeterde vertaling",
        "subtitle": "Automatisch · Linguise AI",
        "empty_title": "Nog niet gegenereerd voor deze tekst",
        "empty_description": "Linguise AI levert natuurlijkere vertalingen op basis van de context van uw pagina en website. Zo krijgt u er hier een:",
        "empty_step_1": "Ga naar AI-vertaling › Instellingen en stel AI-vertaling inschakelen in op “Alleen regels”, “Alleen live-editor” of “Regels en live-editor”.",
        "empty_step_2": "Pas het toe met een regel die bij deze pagina past, of schakel het pagina voor pagina in vanuit de live-editor.",
        "empty_step_3": "De AI-verbeterde vertaling verschijnt hier zodra deze is gegenereerd. Hiervoor worden uw AI-credits gebruikt.",
        "open_settings": "AI-vertaalinstellingen openen",
        "open_editor": "Live-editor openen",
        "overrides_selection": "Uw keuze is opgeslagen, maar in plaats daarvan wordt deze AI-verbeterde vertaling getoond omdat “Handmatige en geselecteerde vertalingen overschrijven” op Ja staat in de AI-vertaalinstellingen. Schakel die instelling uit om uw keuze te gebruiken.",
        "overrides_version": "De versie die u hebt gekozen is opgeslagen, maar in plaats daarvan wordt de nieuwste AI-verbeterde versie getoond omdat “Handmatige en geselecteerde vertalingen overschrijven” op Ja staat in de AI-vertaalinstellingen. Schakel die instelling uit om de gekozen versie te gebruiken."
      },
      "manual": {
        "title": "Handmatige vertaling",
        "subtitle": "Door u geschreven · heeft voorrang op automatische vertalingen",
        "empty": "Leeg",
        "saved_but_overridden": "Opgeslagen als uw keuze, maar niet automatisch getoond omdat “Handmatige vertalingen overschrijven” op Ja staat in de AI-vertaalinstellingen: de AI-verbeterde vertaling wint totdat die instelling wordt uitgeschakeld.",
        "ignored": "Niet automatisch getoond omdat “Handmatige vertalingen overschrijven” op Ja staat in de AI-vertaalinstellingen. Selecteer deze om hem voor deze tekst te gebruiken.",
        "label": "Uw vertaling",
        "placeholder": "Typ uw eigen vertaling...",
        "last_updated": "Laatst bewerkt {{date}}",
        "save_hint": "Door een handmatige vertaling op te slaan, wordt deze actief.",
        "delete": "Handmatige vertaling verwijderen",
        "delete_confirm": "Bevestig het verwijderen van de handmatige vertaling"
      }
    },
    "history": {
      "title": "AI-verbeterde versies",
      "subtitle": "Elke hergeneratie vanuit de live-editor wordt bewaard",
      "unknown_model": "Onbekend model",
      "current": "Huidige",
      "restore": "Deze versie herstellen",
      "restore_note": "Bij herstellen wordt die versie de huidige AI-verbeterde vertaling. Er wordt niets verwijderd.",
      "version_of": "Versie {{current}} van {{total}}",
      "hide": "Geschiedenis verbergen ({{total}})",
      "show": "Geschiedenis tonen ({{total}})"
    },
    "choose": {
      "title": "Vertalingen in {{language}} · kies welke bezoekers zien",
      "current": "Momenteel op uw website:",
      "priority": "Standaardprioriteit: Handmatig › AI-verbeterd › Basis. Uw keuze wordt alleen voor deze vertaling opgeslagen.",
      "reset": "Terugzetten naar standaardprioriteit",
      "reset_title": "Uw keuze voor deze tekst vergeten en weer de standaardprioriteit gebruiken",
      "resetting": "Terugzetten ..."
    }
  },
  "translations": {
    "title": "Beheer van de vertalingen",
    "description": "Zet al je website vertalingen op een rij en bewerk ze; voor een visuele vertaling gebruik je de Live Editor",
    "filter_languages": "Filter op talen...",
    "filter_original": "Filter tekst in originele taal",
    "filter_translation": "Filter op vertaalde tekst",
    "table": {
      "original": "Origineel",
      "language": "Taal",
      "action": "Actie",
      "base": "Basis",
      "ai": "AI-verbeterd",
      "manual": "Handmatig"
    },
    "filter_exact": "Exacte match",
    "badge": {
      "active": "Actief",
      "overrides_manual": "Overschrijft handmatig"
    },
    "cell": {
      "none": "geen",
      "not_generated": "niet gegenereerd",
      "ignored": "Genegeerd – AI-regel wint"
    },
    "tabs": {
      "all": "Alle",
      "manual": "Met handmatig",
      "ai": "Met AI-verbeterd",
      "base": "Alleen basis"
    },
    "levels_hint": "Elke tekst heeft maximaal 3 niveaus — het niveau met Actief is wat bezoekers zien."
  },
  "url": {
    "main": {
      "parent": "URL's",
      "edit": "URL vertaling bewerken"
    },
    "form": {
      "original": {
        "title": "Origineel in {{language}}"
      },
      "translation": {
        "title": "URL vertaling in {{language}}",
        "description": "URL die je wilt overschrijven",
        "placeholder": "Url vertaling overschrijven",
        "invalid_full": "U probeert te wijzigen met een onjuist formaat. Wijzig alleen de slugs/padnaam van de URL-vertaling",
        "invalid": "Ongeldige URL/pad opgegeven"
      }
    }
  },
  "urls": {
    "title": "URL's beheer",
    "description": "Alle vertaalde inhoud van je website URL's opsommen en bewerken (geavanceerd, pas op voor 404-fouten)",
    "filter_languages": "Filter op talen...",
    "filter_original": "Filter tekst in de originele taal",
    "filter_translation": "Filter op vertaalde tekst",
    "table": {
      "original": "Origineel",
      "language": "Taal",
      "url": "Vertaalde URL",
      "action": "Actie",
      "edited": "De originele vertaling is bewerkt"
    }
  }
}
